export default __webpack_public_path__ + "static/media/volume-chart-img.6e13cadc.svg";